import BaseStore from "./BaseStore";

class SettingStore extends BaseStore {


  uploadLogo (files) {
    const data = new FormData();
    for (let x = 0; x < files.length; x++) {
      console.log(files[x])
      data.append("files[]", files[x].file);
    }

    this.axios.put(`/docs/100/add_file`, data, {
      //time out about 3 hours
      timeout: 10000000
    });

    //TODO: Check Backend response
    return this.axios.put(`/global_settings/update_logo/`, data, {
      //time out about 3 hours
      timeout: 10000000
    });
  }

  getLogo(){
    return this.axios.get('/global_settings/get_logo');

  }

  getSlogan(){
    return this.axios.get('/global_settings/get_slogan');

  }

  getVersion(){
    return this.axios.get('/global_settings/get_version');

  }

  supportSearch(q) {
    return this.axios.get("/global_settings/support_search", { params:{ q: q }});
  }

  updateSlogan(slogan) {
    return this.axios.put("/global_settings/update_slogan/" , {slogan: slogan});
  }

  updateVersion(ver) {
    return this.axios.put("/global_settings/update_version/", {version: ver});
  }

  historyPermissions (){
    return this.axios.get("/global_settings/list_permissions_history");
  }
}
export default new SettingStore();



// WEBPACK FOOTER //
// ./src/stores/SettingStore.js